import { defineComponent as _defineComponent } from 'vue'
import SectionTitle from './section-title.vue';
	import SubSection from './sub-section.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'remember-section',
  setup(__props) {

	
return { __sfc: true,SectionTitle, SubSection }
}

})